import { render, staticRenderFns } from "./OfferVersionDropdown.vue?vue&type=template&id=6c5779c4&scoped=true&"
import script from "./OfferVersionDropdown.vue?vue&type=script&lang=js&"
export * from "./OfferVersionDropdown.vue?vue&type=script&lang=js&"
import style0 from "./OfferVersionDropdown.vue?vue&type=style&index=0&id=6c5779c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5779c4",
  null
  
)

export default component.exports